<section [attr.data-theme]="theme()" class="theme-border side-menu-container">
    <div class="flex items-center gap-1 px-5 border-b select-none py-7 theme-border">
        <!-- <img [src]="logo() || 'https://lepisode.team/assets/logo.svg'" />
    <p [attr.data-theme]="theme()" class="text-lg font-semibold theme-text">
      {{ title() }}
    </p> -->
        <p class="logo-text">Smart</p>
        <p class="logo-text">Solution</p>
    </div>
    <div class="flex flex-col gap-1">
        <ng-content />
    </div>
</section>
